<template>
  <div class="ipt-wrap">
    <div class="second-title">
      <div>
        <img class="wen9" src="~assets/images/home/wen9.png" />
      </div>
    </div>
    <div class="wrap">
      <div class="wrap-cont">
        <label>姓<span style="opacity: 0">略</span>名</label>
        <div class="cont">
          <input type="text" v-model="name" placeholder="请输入真实姓名" />
        </div>
      </div>
      <div class="wrap-cont">
        <label>手机号</label>
        <div class="cont">
          <input type="tel" v-model="phone" maxlength="11"  placeholder="请输入您的手机号码" />
        </div>
      </div>
      <div class="wrap-cont">
        <label>验证码</label>
        <div class="cont">
          <input type="number" v-model="yzcode" oninput="if(value.length>6)value=value.slice(0,6)"
          placeholder="请输入验证码" />
          <button class="setdata" :class="{'is-send':isSend}" @click="getCode">{{isSend? `重新发送(${time}S)`:isFirst?'获取验证码':'重新发送'}}</button>
        </div>
      </div>
      <div class="wrap-cont">
        <label>微信号</label>
        <div class="cont">
          <input type="text" v-model="wxNum" maxlength="20" placeholder="请输入您的微信号码" />
        </div>
      </div>
      <a class="btn" @click="submitMsg">立即加盟</a>
    </div>
    <van-popup class="popup"  closeable
   close-icon="close"  close-icon-position="bottom"
   v-model="show" get-container="body">
       <div class="wrap">
        <h3>提交成功</h3>
        <img src="~assets/images/home/2_06.png?v1">
        <p>您可截图添加微信了解详情</p>
       </div>
    </van-popup>
  </div>
</template>

<script>
import { regExp } from "../../utils/index";
import {saveInfo,getCode} from "../../api";

export default {
  name: "index",
  props: {
    isLine: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  data() {
    return {
      value: "",
      name: "",
      phone: "",
      wxNum: "",
      show: false,
      yzcode:'',
      isSend:false,
      time:60,
      isFirst:true
    };
  },
  methods: {
    submitMsg() {
      if (!this.name || !this.phone || !this.wxNum) {
        return this.$toast("您还未填写\n正确的联系方式");
      } else if (!regExp.name.test(this.name)) {
        return this.$toast("请输入正确姓名！");
      } else if (!regExp.phone.test(this.phone)) {
        return this.$toast("请输入正确的电话号码！");
      }
      else if (this.yzcode.replace(/\s/g,'').length==0) {
          return this.$toast("请输入验证码！");
      } else if (!regExp.wx.test(this.wxNum)) {
        this.$toast("请输入正确的微信号！");
        return;
      }
      saveInfo(this.name,this.phone,this.wxNum,this.yzcode).then(res=>{
        if(res.code ==400){
          this.$toast(res.codeMsg || res.data)
        }else if(res.code == 200){
          this.showPopup()
          this.yzcode = ''
          this.name = ''
          this.phone = ''
          this.wxNum = ''
        }
      })

    },
    getContainer() {
      return document.querySelector(".my-container");
    },
     showPopup() {
      this.show = true;
    },
    getCode() {
      if(this.isSend) return
      if(this.phone.replace(/\s/g,'').length==0)return this.$toast("请输入电话号码！");
      if(!regExp.phone.test(this.phone)) return  this.$toast('请输入正确的手机号')
      if(this.isFirst){this.isFirst = false}
      this.isSend = true
      this.$toast('验证码已发送，请及时接收')
      getCode(this.phone).then(res=>{
      })
      let timer = setInterval(()=>{
        if(--this.time<=0){
          this.isSend = false
          this.time = 60
          clearInterval(timer)
        }
      },1000)
    }
  }
};
</script>

<style scoped lang="less">
.second-title {
  text-align: center;
  padding-top: 65px;
  padding-bottom: 20px;
  .wen9 {
    height: 108px;
  }
  p {
    color: #858585;
    margin-top: 10px;
  }
  .underline {
    display: inline-block;
    width: 20%;
    border-bottom: 2px solid #126eac;
    height: 2px;
    margin: 15px 0;
  }
}
.van-popup {
    width: 70vw;
    height: 54vh;
    
}
.popup {
    text-align: center;
    background: transparent;
    .wrap {
        background: #fff;
        border-radius: 5px;
    }
    /deep/.van-popup__close-icon {
        font-size: 80px;
        bottom: 0;
        left: 0;
        right: 0;
        background: transparent;
    
       
        
    }
    h3 {
        font-size: 34px;
        color: #252525;
        padding: 20px 0;
    }
    img {
        width: 80%;
    }
    p {
        font-size: 30px;
        color: #c9c9c9;
        padding: 15px 0 20px 0;
    }
}

.btn {
  padding: 20px 0;
  margin: 0 40px;
  display: block;
  text-align: center;
  background: linear-gradient(90deg, #126eac, #5aaad7);
  font-size: 36px;
  color: #fff;
  border-radius: 5px;
}
.setdata {
  background-color: #287fb5;
  color: #fff;
  border: none;
  white-space: nowrap;
  border-radius: 8px;
  font-size: 24px;
  width: 50vw;
  &.is-send {
    background-color: #cdcdcd;
  }
}
.ipt-wrap {
  background: #fafafa;
  .second-title {
    background: linear-gradient(180deg, #fff, #fafafa);
    margin-bottom: 15px;
  }
  .wrap {
    padding: 0 30px;
  }
  .wrap-cont {
    display: flex;
    flex-wrap: wrap;
    height: 72px;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    label {
      font-size: 36px;
      color: #252525;
    }
    .cont {
      width: 80%;
      display: flex;
      input {
        height: 72px;
        width: 100%;
        /*flex: 1;*/
        padding-left: 40px;
        font-size: 30px;
        background:#fafafa;
        border-bottom: 1px solid #aaa;
        &::-webkit-input-placeholder {
          font-size: 30px;
          color: #c1c1c1;
        }
      }
      /deep/.select {
        width: 40%;
        border-left: 1px solid #f1f1f1;
        .el-input__inner {
          border: none;
          height: 72px;
          font-size: 24px;
        }
        .el-select-dropdown__item {
          height: 50px;
        }
        li {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      /*select {*/
      /*    border: none;*/
      /*    outline: none;*/
      /*    padding: 0 20px 0 40px;*/
      /*    border-left: 1px solid #f1f1f1;*/
      /*    font-size: 30px;*/
      /*    &:focus {*/
      /*        outline: none;*/
      /*    }*/
      /*}*/
    }
  }
  .btn {
    margin: 30px 0 100px;
  }
}
</style>